import {
  darkenHexColor,
  generateColorsFromSeed,
  getSecondaryColor,
  resolveColor,
} from "./colorUtils";

const AVATAR_LIGHTNESS_SCALE = 0.78;
const AVATAR_MIN_LIGHTNESS = 32;
const AVATAR_SATURATION_SCALE = 0.88;
const AVATAR_MAX_SATURATION = 85;

/** Slightly deepen avatar gradient colours for dark UI (waves overlay reads less neon). */
export function toneAvatarGradientColor(color: string): string {
  const hslMatch = color.match(/hsl\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%\s*\)/i);
  if (hslMatch) {
    const h = Number(hslMatch[1]);
    const s = Math.min(
      AVATAR_MAX_SATURATION,
      Math.round(Number(hslMatch[2]) * AVATAR_SATURATION_SCALE),
    );
    const l = Math.max(
      AVATAR_MIN_LIGHTNESS,
      Math.round(Number(hslMatch[3]) * AVATAR_LIGHTNESS_SCALE),
    );
    return `hsl(${h}, ${s}%, ${l}%)`;
  }

  if (color.startsWith("#")) {
    return darkenHexColor(color, 0.18);
  }

  return color;
}

export function toneAvatarGradientColors(colors: {
  color1: string;
  color2: string;
}): { color1: string; color2: string } {
  return {
    color1: toneAvatarGradientColor(colors.color1),
    color2: toneAvatarGradientColor(colors.color2),
  };
}

/** WorkerAvatar gradient colours — name seed or API avatar_colour with harmonized companion. */
export function workerAvatarColors(
  seed: string,
  avatarColour?: string | null,
): { color1: string; color2: string } {
  const hex = avatarColour ? resolveColor(avatarColour) : null;
  if (hex) {
    return { color1: hex, color2: getSecondaryColor(hex) };
  }
  return generateColorsFromSeed(seed);
}

/** Production avatar palette: seed colours toned down for gradient backgrounds. */
export function workerAvatarGradientColors(
  seed: string,
  avatarColour?: string | null,
  explicit?: { color1: string; color2: string },
): { color1: string; color2: string } {
  const base = explicit ?? workerAvatarColors(seed, avatarColour);
  return toneAvatarGradientColors(base);
}
